// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-f651f522]{width:100%;border-collapse:collapse}td[data-v-f651f522],th[data-v-f651f522]{border-bottom:1px solid #000}.sub[data-v-f651f522]{position:absolute}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
